import { queryOptions } from '@tanstack/react-query'

import {
  fetchShipmentOrderImportFormats,
  type FetchShipmentOrderImportFormatsQuery
} from '../api'
import { shipmentOrderImportFormatsQueryKeys } from '../query-keys'

export const getShipmentOrderImportFormatsQueryOptions = (
  query: FetchShipmentOrderImportFormatsQuery
) =>
  queryOptions({
    queryKey: shipmentOrderImportFormatsQueryKeys.list(query),
    queryFn: async ({ signal }) =>
      fetchShipmentOrderImportFormats(query, signal)
  })
